import templateUrl from './timeline-sequence.html';

export const timelineSequenceComponent = {
    bindings: {
        details: '<'
    },
    templateUrl,
    controller: class TimelineSequenceComponent {
        constructor($state, toastr, ModalService, TimelineService, CompareObjectService) {
            'ngInject';
            this.$state = $state;
            this._toastr = toastr;
            this.modalService = ModalService;
            this.TimelineService = TimelineService;
            this.compareObjectService = CompareObjectService;
        }
        $onInit() {
            this.details = this.details.sort(function (a, b) {
                let aKey = a.sortOrder, bKey = b.sortOrder;
                if (aKey < bKey) return -1;
                if (aKey > bKey) return 1;
                return 0
            })
            this.savedData = angular.copy(this.details);
        }
        //after submit set new sort Order
        onSubmit() {

            let sequenceObject = angular.copy(this.details);
            sequenceObject = sequenceObject.map((item, index) => {
                let data = {
                    timelineId: item.id,
                    sortOrder: index + 1,
                }

                return data;
            });
            this.TimelineService.editTimelineSequences(sequenceObject).then((result) => {
                this._toastr.success("Timeline Sequence Changed");
                this.$state.go('timeline');
            }).catch((err) => {
                this._toastr.error("something went wrong");
            });
        }

        //on cancel page must be redirect to `banners` page
        onCancel() {
            const compareObj = angular.copy(this.details);

            const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, compareObj, false);

            if (isUpdated) {
                this.modalService.open({
                    details: {
                        bodyMessage: 'Changes done will be reverted. Continue?'
                    },
                    buttons: [{
                        name: 'No',
                        action() {
                        }
                    }, {
                        name: 'Yes',
                        isPrimary: true,
                        action: _onSubmit.bind(this)
                    }]
                });

                function _onSubmit() {
                    this.$state.go('timeline');
                }
            } else {
                this.$state.go('timeline');
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline-sequence/timeline-sequence.component.js